module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title0"
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "ch-title1"
  }, [_vm._v("Blood and Sand")]), _vm._v(" "), _c('h3', {
    staticClass: "sect1"
  }, [_vm._v("I")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In spite of her resolve not to make a fool of herself at her first bull-fight, Janell Lincoln began to tremble when the trumpet-call ended on a shrill brassy note and the crowded amphitheatre became quiet and tense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The trumpeter looked exactly like a vain little monkey decked out in rose and gold as he took the instrument from his lips and bowed. Then, unperturbed by the fact that no ovation was forth-coming, he smiled proudly and canted his head to listen to the echo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The echo took a long, long time to die in the crooked shimmer of heat which rose from the arena toward the hard blue sky and the dazzling white clouds wandering in from the Gulf of Mexico. It rang in the girl’s ears, and she thought: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s a tiny live thing that wants to escape, but can’t!")]), _vm._v(" She had a momentary nightmarish sensation of being trapped there too—in an inverted glass bowl which was lined by tier upon tier of dark, strange faces and clamped down tightly upon a round floor of yellow sand. Sand that was furrowed deeply and splotched by damp red stains.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She slid a hand over the hot concrete and felt her father’s fingers close over it. They were strong and gentle surgeon’s fingers whose touch always carried reassurance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Feel all right?” he asked. “If you want to go—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, no.” She shook her head firmly. It had been her suggestion that they should come across the Rio Grande to this dedication of Matamoros’ new arena. He had agreed reluctantly. She had"), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("\nnoticed his effort to detain her as long as possible outside, dispatching post cards to\nschool friends up north. “Christmas Day, and I’m on my way to a bullfight!”")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("His luminous grey eyes were regarding her keenly, and there was an anxious look on his face. She hadn’t become accustomed yet to the rich, even coat of tan which he had been acquiring, or to the flesh which had rounded out his cheeks, softening the old angularity of his profile. With his broad shoulders stretching the cloth of his white tropical worsted coat and the sun glinting upon the grey hairs at his temples, he was, she decided again, a distinguished and handsome man. He held his Panama hat upside down between his knees, lest it serve as a target for an orange peel or worse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She moved closer to the loop of iron which separated their seats. “Really, I’m thrilled by it. What happens now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("banderillas")]), _vm._v("—the darts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes followed his to the arena, where the bull stood, his attention fixed on something which was hidden from her sight by the red wooden fence. A massive coal-black creature with long symmetrical horns, he was motionless save for an occasional twitch of the tail and an impatient pawing of the sand. They were on the east side, close down in the sun, so that his shadow loomed hugely toward them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A ripple of applause went over the stands, and her father said: “Carlos Campos. Evidently he’s going to place the darts. Usually the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("matador")]), _vm._v(" lets someone else do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She leaned forward to get an uninterrupted view of the young man who had stepped out from the shade, brandishing in each hand a barbed stick from which dangled strips of coloured paper. He was taller than most Mexicans, and his skin-tight green-and-silver trousers and jacket set off to advantage the contours of a sinewy body. He held his head high, to smile at the crowd, and the sun played upon his dark-olive mobile face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So that’s Carlos Campos!” she murmured.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("“Yes.” Dr. Lincoln watched the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("matador")]), _vm._v(" move with graceful springing steps over the sand. “I’m glad his father can’t see him now.”")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You told me that he wouldn’t let Carlos go into the ring, didn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. He always opposed it. But Carlos had the fever, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("afición ")]), _vm._v("the Mexicans call it, and practiced with young bulls on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hacienda.")]), _vm._v(" He got quite a local reputation. Partly because he’s left-handed, and that’s a novelty. But he waited until his father’s death before he appeared in public.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Campos had stopped within six yards of the bull and was rising lightly on his toes, lifting one dart and then the other to arm’s length. Like a man going tentatively through setting-up exercises.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly he advanced, with a swift circular movement, and drove the barbs into the animal’s neck, close together, directly behind the head. The bull gave a low, angry bellow, but seemed too surprised to attack. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("banderillas")]), _vm._v(" fell forward, aslant on either side of his face, and began to drip. The blood glistened brightly in the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In front of them a Mexican in a tight black suit and little straw hat was consuming a cigarette with quick, nervous puffs, never taking the tube from his lies. Wisps of smoke floated back into Janell’s face with a sickening, sweet odour like cheap incense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned her head away and glanced over the stands. When her father began to fan her gently with his hat she managed another smile. “I’m all right. It’s just the sun and the crowd and—and people staring at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Staring is as much a part of the entertainment as the bulls. It’s not considered rude in Mexico. And”—he patted her hand—“you can’t blame them when such a good-looking girl sits here with an old fossil like me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She noticed, however, that he raised his eyes and scanned the near-by rows. “Up in that box,” she told him, “a man’s been staring at me through field-glasses.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("He looked up at the row of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("palcos")]), _vm._v(" high up on the south side, his smile broadened, and he waved a hand in greeting. “They’re friends,” he said in a relieved tone. “The young fellow with the glasses is Kent Distant. The other is Hugh Rennert. You haven’t met either of them, have you?”")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Who’s Hugh Rennert?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A newcomer to our neighbourhood. He’s building that house a couple of miles east of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yes. That brick bungalow.” The neighbourhood, she knew, meant that little community a few miles outside of Brownsville which combined so happily the advantages of city, suburbs and country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rennert used to be with the United States Customs Service. His father died recently and left him some money, I understand, so he resigned and came to Cameron County to grow citrus fruit.” She realized that her father’s purpose was to give her an opportunity to disregard what was happening below. “Kent Distant is the son of an acquaintance of mine—David Distant. You may have heard me speak of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Oklahoma Indian?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. David is supposed to spend Christmas in Brownsville. Kent came down from Washington to meet him. He’s studying for the Foreign Service there. He’s staying at the Jester Hotel, on the highway above our place, you know. I’ve been intending to ask him over for dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, why don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His eyes had a twinkle, but behind that, she saw, they had become thoughtful. “You’d like me to?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, yes. It’d be fun to meet an Oklahoma Indian.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Kent’s half Indian. A fine young man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a moment of silence. Janell said to him sternly: “I believe, my dear, you have that look in your eyes. Turn your head this way. Yes, you have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mind telling me what you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s that predatory look mothers get when an unmarried male comes within range of a daughter who’s been left on their hands. You’re forgetting that I’m going to be an old maid and keep house for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you might have changed your mind since last summer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course not.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("He astonished her by dropping his bantering tone and saying: “You don’t want to take that resolution seriously, Janell.”")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She was vaguely uncomfortable and didn’t respond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something might happen to me, you know,” he went on gravely. “That would leave you very much alone in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t say that!” She gripped his arm tightly. “Why, nothing could possibly happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His mood changed again, he laughed and glanced upward. “All right. Sorry. I think Kent’s on his way down here. Want this?” He held out the purse which she had put into his pocket for safe keeping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She took it absently, located mirror and lipstick. She was surprised to see the paleness of her face, the nervous brightness of the deep-set eyes which were so much like her father’s. Strands of ash-blonde hair which should have been fluffy clung damply to her forehead, under the brim of her navy-blue straw hat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But her thoughts were on her father. She had had no idea that he could still slip so easily into the dark apprehensive mood which used to worry her so. True, this had been a calamitous winter for communities like his at the southernmost tip of Texas. Early in the fall the tropical hurricane had swept in from the Gulf, raking the Magic Valley with its fury. There had been enormous damages to the citrus fruit orchards upon which everyone depended, directly or indirectly, for a livelihood. She knew from his letters that the suffering which he had witnessed then had left its trace upon him. And it was such a few years before that he had seen her mother’s body brought mangled from the wreckage of a train.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A deafening roar of applause went up from the lower rows, and she hastily replaced the contents of the purse and slipped it into her father’s pocket again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("matador")]), _vm._v(" had affixed his third pair of darts and was disappearing beneath the fence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A shadow fell across them and a soft, pleasant voice said: “Hello, Doctor. Enjoying the fight?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Lincoln looked up and smiled at the tall young man in whites who stood in the aisle. “Hello, Kent. Yes, we’re determined to enjoy it.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The newcomer removed his hat and leaned over, with one hand upon the iron loop at Lincoln’s shoulder. As he did so his eyes (of")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v(" such a dark brown that they appeared black) rested on Janell, and he smiled. She was a bit disappointed that he wasn’t markedly different from the young men she knew in college. Many of them had hair just as black and straight, cheek-bones and noses no more prominent than his. He was good-looking, self-confident, but that was all. She knew from her father’s expression that he was going to try to be humorous.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you heard from your father yet, Kent?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.” Distant looked at Janell again. “Not a word. I thought he’d be here in time to join me this afternoon. So I got a box with two seats. When he didn’t show up I persuaded Mr. Rennert to come along.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t know Rennert was a bullfight fan.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s not. But he had an errand in Matamoros, so I talked him into coming with me.” He cleared his throat. “We thought you folks might like to trade seats with us. You’d be more comfortable in the shade.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why—watch out!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Distant ducked his head just in time to escape an orange peel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Lincoln laughed. “Lucky that wasn’t a beer bottle, Kent.” He looked rather sharply at the young man, who was glaring back at the packed rows. “Pretend you didn’t notice it. Otherwise you’ll have a whole crate of fruit sailing down here. Oh, excuse me!” he said, with an elaborate note of apology. “I was forgetting about you, Janell. This is Kent Distant, whom we were just discussing. My daughter Janell, Kent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They acknowledged the introductions, and she said: “Thank you, Mr. Distant, but we couldn’t deprive you of your seats.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, that’s all right. We won’t mind the sun. Mr. Rennert sent a message to you, Doctor. If you’ve had enough of the fight, he’ll buy you a beer outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, well, tell him I accept with pleasure. You take Janell with you. Have Rennert join me here. As soon as this bull is killed we’ll leave. Meet you by the exit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well—” Distant hesitated. “If you’re quite sure—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("“Quite all right, my boy. Take good care of the little girl.”")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Janell felt a big hand close about her elbow, assisting her up the concrete steps. All along the aisle heads turned in her direction, and she was aware of the intense direct gaze of black jewellike eyes. She couldn’t understand why she felt so terribly embarrassed, why she felt impelled to smooth down the skirt of her linen suit. One was stared at when leaving a football game, of course. But this was different….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mustn’t pay any attention to what Father said. He was trying to have some fun out of me. We weren’t really discussing you. I just happened to see you looking at me through those glasses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, that!” Distant chuckled. “We were studying the facial expressions of the crowd. Mr. Rennert says that’s more interesting than what happens in the arena.” They crossed the ramp and started up another flight of steps. It was shaded, however, and cooler. “We turn to the right here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He guided her along another narrower ramp, near the top of the amphitheatre, and into a small cubby-hole open on the side which faced towards the ring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A middle-aged man in the inevitable white lightweight clothing rose as they entered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miss Lincoln,” Distant said, “this is Mr. Rennert. Janell Lincoln, Mr. Rennert.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad to know you, Mr. Rennert. Father says you’re to be a neighbour of ours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, as soon as my house is finished.” He was tanned, as she had come to expect all men to be in this land of year-round sunshine. She liked his ready smile and the friendly look in his dark-brown, grey-flecked eyes. “What did Dr. Lincoln say to my offer of a beer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He agreed at once.” She sat in the chair which Kent drew back for her. “Poor Father, he’s perfectly miserable. He only came because I wanted him to. He said to join him and he’d have a beer with you after this bull is killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll be going then. There’s the last trumpet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The last one?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“Yes. The signal for the kill.”")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('h3', {
    staticClass: "sect1"
  }, [_vm._v("II")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice fellow, isn’t he? I got acquainted with him at the hotel.” Kent pulled his chair forward so that he could gaze over the ledge. “The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("matador")]), _vm._v(" is going to give his toast to the mayor now. Want to use these glasses?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks. You’ve seen bullfights before?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, but I’ve read about them.” He laughed. “Mr. Rennert says that’s the only way to get a great emotional experience out of a bullfight. To stay at home and read about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The height and the lenses put a different aspect on the scene. The heat waves fused the sand into a lake of molten gold, in which the bloodstains and filthiness were dissolved from view. Campos, too, looked more impressive as he walked across the arena, holding the folds of his gold-embroidered cape in his right hand. It passed round his body in the opposite of the accustomed fashion, so that his left arm was free.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Spanish say that the heart of a bullfight crowd is a woman’s heart, captivated by colour and pomp and more than all else by blatant maleness. Campos must have known this, for he moved his legs so that the sunlight played upon his thighs and loins and revealed the rippling of the muscles under the tight trousers. The amphitheatre grew still again, filled with the orgiastic tremor of heavy breathing and hot, tense bodies perspiring under the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janell felt a return of the anticipatory excitement with which she had entered the place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Enjoying it, isn’t he?” Distant commented. “This is his first appearance, they say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In public, yes. He used to fight bulls on the family "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hacienda ")]), _vm._v("south-west of here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right. Dad visited there three or four years ago.” He turned to her. “That’s where he met your father, wasn’t it? And—oh, I’m terribly sorry!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She kept the glasses to her eyes. “Yes, that was when Mother was killed in a train wreck. Is that why your father is coming down—to testify for Dr. Torday?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“Torday? The man who had his neck broken but lived?”")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. The Mexican National Railways are trying to break their indemnity agreement with him. He owns a radio station here in Matamoros. And a sanatorium down on the Gulf. Father’s on the staff there. Tonatiuh, they call it, the Aztec name for the sun.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Testifying is only incidental with Dad. But Torday heard that he was coming and asked him to be ready to if it was necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This Carlos Campus is to be one of the witnesses, too. It was on his father’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hacienda")]), _vm._v(" that the accident took place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s another man here who was on the same trip. Mr. Bettis. He manages the Jester Hotel, where Mr. Rennert and I are staying. We were watching his face a few minutes ago. He’s in the same section you were in—F.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s see what people look like from up here.” She surveyed the east side of the amphitheatre.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“There’s")]), _vm._v(" Bettis. On the first row of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tendidos.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tendidos")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. The first row of seats, just behind the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("callejón,")]), _vm._v(" or runway, is called the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("barrera.")]), _vm._v(" The next is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("contrabarrera.")]), _vm._v(" Then come the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tendidos,")]), _vm._v(" the twelve rows in front of the gallery. Locate Bettis? Three seats from the right aisle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She focused the glasses upon a short fleshy man, probably in his early forties, the vacuity of whose face might have been due partially to huge tortoiseshell spectacles. He had thin corn-coloured hair plastered down so that it almost, but not quite, concealed the bald spot on the top of his head. He was leaning forward, as if in the grip of excitement, and his knees seemed to be crushing the crown of his straw hat. As she watched he drew from his pocket a flat silver case and extracted a cigarette.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He didn’t bat an eye when the horses were gored,” Distant said. “Quite a contrast to that other American a few seats farther on in the same row. I’ve forgotten his name, but Mr. Rennert knows him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, that’s Professor Radisson. We didn’t know he was coming or we’d have brought him with us. He has an apartment in the old carriage house back of us.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“What’s he professor of?”")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“He isn’t really a professor any more, but everyone calls him that. He’s making a study of Indian languages in Northern Mexico. Been at it for years. He makes his headquarters in Brownsville part of the time.”\n")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a woodenness about Radisson’s posture, as if his head were held in position by an old-fashioned photographer’s clamp. There was a woodenness, too, about his face, which was burnt by the sun to such a deep mahogany that it had the impassivity of a Mexican’s. He looked about the same height as Bettis, but older. In contrast one got the impression that his tan-coloured suit of tropical worsted covered a wiry body of solid bone and muscle. He had close-cropped, dark brown hair, worn pompadour fashion, and a short bristling moustache. He, too, had laid his hat upon his lap, and his brown fingers, playing with its brim, were the only part of him which showed any trace of agitation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was interested in watching him,” Distant said. “He looks callous. But he turned his head away every time a horse was hurt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s a very nice man, according to Father. I don’t know him very well. He always has acted a little brusque, but Father says that’s because he’s really self-conscious, and has lived by himself so long. He’s one of Dr. Torday’s witnesses too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He is? The judge might as well hear the case here, mightn’t he? I suppose they’re here because they know Campos.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A roar drew their attention back to the west side of the stands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Campos has finished his speech,” Distant examined. “He’s going to pose for a picture.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("matador")]), _vm._v(" had moved back a few steps and taken up a theatrical stance, his left hand pointing a long bright sword at the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The photographer, a young Mexican or American—they couldn’t be sure which—stood in the runway and balanced his camera on top of the fence. He finished, and waved a hand to Campos.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The latter unfastened his cloak, flung it across the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("barrera,")]), _vm._v(" and took from an attendant a spiked stick over which was folded a scarlet cloth.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("muleta,”")]), _vm._v(" Distant said.")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He squared his shoulders, raised and lowered his arms again, and strode towards the bull. He got to within three yards this time before he stopped. He extended the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("muleta")]), _vm._v(" in his right hand and began to move very slowly in a circle. The animal’s head followed him as if the two of them were strung on a single invisible wire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Testing him. Deciding which pass to make. By George, he’s going to try a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, watch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Campos advanced and flicked the cloth toward the bull’s nose. As the beast charged, he swayed, without moving his feet, and swept the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("muleta")]), _vm._v(" backward until the two of them had completed a quarter-circle. Then he flapped the lower part of the cloth again, stopped, and—magically—the bull stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Distant nodded judicially. “The fellow’s not bad. And left-handed, too! See what happens? The bull charges the rag, not the man. There they go again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was the same pass, even more skillfully executed. One had the illusion that the man’s arm was swinging not only the bit of cloth but a black inert mass five times larger than he.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Campos went through four of these exhibitions, always coming to a standstill with his back to the sun. Then he went in for the kill. The Moment of Truth, Spaniards call it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He raised his left hand and pointed the sword straight at the tiny vital spot between the bull’s shoulder-blades. He moved forward, extending the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("muleta")]), _vm._v(" beyond his left side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again the bull charged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But, as if a taut wire had snapped in a puppet-play, something went wrong. What looked like a spasm of pain contorted the man’s face and he jerked his head to one side. His sword spun away from his hand, and the next moment he was writhing grotesquely through the air.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1029d7dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Chapter01.vue
// module id = 75
// module chunks = 0